export const VIC_STATE_OPTION = { label: 'VIC', value: 'VIC' };

export const VIC_HOUR_OPTIONS = [
    { value: 2, label: '2' },
    { value: 3, label: '3' },
];

export const VIC_AUTHORITY_OPTIONS = [
    {
        value: 'agent_appointed_by_the_requestor',
        label: 'Agent appointed by the requestor',
        cost: 0,
        halfHourRate: 0,
        requiresLOA: true,
    },
    {
        value: 'other',
        label: 'Other',
        cost: 0,
        halfHourRate: 0,
        requiresLOA: true,
    },
];
